import Cookies from "universal-cookie";

const VITE_API_HOST = import.meta.env.VITE_API_HOST;
const loggedAsAdminCookie = `logged_as_admin_${VITE_API_HOST}`;

const cookies = new Cookies();

export const createLoggedAsAdmin = () => {
  cookies.set(loggedAsAdminCookie, "true", {
    path: "/",
    maxAge: 7200, // 2 godziny dla sesji administratora
  });
};

export const readLoggedAsAdmin = () => {
  return cookies.get(loggedAsAdminCookie);
};

export const updateLoggedAsAdmin = () => {
  if (readLoggedAsAdmin()) {
    createLoggedAsAdmin();
  }
};

export const deleteLoggedAsAdmin = () => {
  cookies.remove(loggedAsAdminCookie, { path: "/" });
};

export { loggedAsAdminCookie };
